module.exports = __webpack_public_path__ + "static/img/logo8.a506822.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo8.png
// module id = 2X6U
// module chunks = 1